module.exports = __webpack_public_path__ + "img/wiki.d2eb86a1.svg";